var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comtainer-main"},[_c('div',{staticClass:"tag"},[_vm._v("你的浏览器暂不支持，建议使用支付宝或微信浏览！")])])}]

export { render, staticRenderFns }